"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PopoverAnchorWrapper = exports.PopoverBody = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/* Create our own stacking context and root for our absolutely positioned pop over */
var PopoverAnchorWrapper = (0, _styledComponents["default"])('div').withConfig({
  displayName: "usePopoverstyles__PopoverAnchorWrapper",
  componentId: "sc-1s4kaza-0"
})(["position:relative;"]);
exports.PopoverAnchorWrapper = PopoverAnchorWrapper;
var PAD = '12px';
var PopoverBody = (0, _styledComponents["default"])('div').withConfig({
  displayName: "usePopoverstyles__PopoverBody",
  componentId: "sc-1s4kaza-1"
})(["position:absolute;box-shadow:0 0 6px #00000029;background-color:white;border-radius:6px;width:fit-content;", " &::after{content:'';width:", "px;height:", "px;clip-path:polygon(-20px -20px,calc(100% + 20px) -20px,calc(100% + 20px) calc(100% + 20px));background-color:white;position:absolute;box-shadow:0 0 6px #00000029;", "}"], function (props) {
  /* Place the Popover box according to position and alignment */
  switch (props.position) {
    case 'top':
      {
        return (0, _styledComponents.css)(["bottom:calc(100% + ", ");margin-bottom:", "px;", ":-", ";"], PAD, props.arrowSize, props.align === 'start' ? 'left' : 'right', PAD);
      }

    case 'right':
      {
        return (0, _styledComponents.css)(["left:calc(100% + ", ");", ":-", ";margin-left:", "px;"], PAD, props.align === 'start' ? 'top' : 'bottom', PAD, props.arrowSize);
      }

    case 'left':
      {
        return (0, _styledComponents.css)(["right:calc(100% + ", ");", ":-", ";margin-right:", "px;"], PAD, props.align === 'start' ? 'top' : 'bottom', PAD, props.arrowSize);
      }

    default:
    case 'bottom':
      {
        return (0, _styledComponents.css)(["top:calc(100% + ", ");margin-top:", "px;", ":0;"], PAD, props.arrowSize, props.align === 'start' ? 'left' : 'right');
      }
  }
}, function (props) {
  return Math.sqrt(Math.pow(props.arrowSize, 2) + Math.pow(props.arrowSize, 2));
}, function (props) {
  return Math.sqrt(Math.pow(props.arrowSize, 2) + Math.pow(props.arrowSize, 2));
}, function (props) {
  /* 
    Place the Popover arrow according to position and alignment
    We need to rotate the :after, because we are dealing with a clipped rectangle.
  */
  switch (props.position) {
    case 'top':
      {
        return (0, _styledComponents.css)(["top:calc(100% - ", "px + 1px);transform:rotate(135deg);", ":", "px;"], props.arrowSize, props.align === 'start' ? 'left' : 'right', props.arrowSize * 2);
      }

    case 'right':
      {
        return (0, _styledComponents.css)(["right:calc(100% - ", "px + 1px);transform:rotate(-135deg);", ":", "px;"], props.arrowSize, props.align === 'start' ? 'top' : 'bottom', props.arrowSize * 2);
      }

    case 'left':
      {
        return (0, _styledComponents.css)(["left:calc(100% - ", "px + 1px);transform:rotate(45deg);", ":", "px;"], props.arrowSize, props.align === 'start' ? 'top' : 'bottom', props.arrowSize * 2);
      }

    case 'bottom':
    default:
      {
        return (0, _styledComponents.css)(["bottom:calc(100% - ", "px + 1px);transform:rotate(-45deg);", ":", "px;"], props.arrowSize, props.align === 'start' ? 'left' : 'right', props.arrowSize * 2);
      }
  }
});
exports.PopoverBody = PopoverBody;